import { render, staticRenderFns } from "./ItemIcon.vue?vue&type=template&id=40d73ea4&scoped=true&"
import script from "./ItemIcon.vue?vue&type=script&lang=js&"
export * from "./ItemIcon.vue?vue&type=script&lang=js&"
import style0 from "./ItemIcon.vue?vue&type=style&index=0&id=40d73ea4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d73ea4",
  null
  
)

/* custom blocks */
import block0 from "./ItemIcon.vue?vue&type=custom&index=0&blockType=docs&lang=md"
if (typeof block0 === 'function') block0(component)

export default component.exports